import { StickyNote } from "lucide-react";

interface Props {
  text?: string;
}

export default function MinisiteNotes({ text }: Props) {
  if (
    !text ||
    !text.trim() ||
    text.trim() === "<p></p>" ||
    text.trim() === "<p><br></p>"
  ) {
    return null;
  }

  const isHtml = /<[a-z][\s\S]*>/i.test(text);

  return (
    <section className="rounded-2xl bg-card border border-border/80 shadow-xs overflow-hidden transition-all">
      <div className="border-b bg-muted/30 px-5 py-3.5 flex items-center gap-2.5">
        <div className="h-7 w-7 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
          <StickyNote className="h-4 w-4" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-foreground">
            Note del preventivo
          </h3>
          <p className="text-xs text-muted-foreground">
            Comunicazioni e dettagli importanti dal nostro staff
          </p>
        </div>
      </div>
      <div className="p-5">
        {isHtml ? (
          <div
            className="prose prose-sm dark:prose-invert max-w-none w-full overflow-hidden break-words text-foreground/90 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <div className="text-sm text-foreground/90 leading-relaxed whitespace-pre-line break-words">
            {text}
          </div>
        )}
      </div>
    </section>
  );
}
